/* import __COLOCATED_TEMPLATE__ from './sku-payload.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface TasksKitListSkuPayloadSignature {
  Args: {
    id: unknown;
    payload: unknown;
  };
  Element: HTMLElement;
}

const TasksKitListSkuPayloadComponent = templateOnlyComponent<TasksKitListSkuPayloadSignature>();

export default TasksKitListSkuPayloadComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::SkuPayload': typeof TasksKitListSkuPayloadComponent;
    'tasks-kit/list/sku-payload': typeof TasksKitListSkuPayloadComponent;
  }
}
